import React from "react";
import HeroSection        from "./Home/HeroSection";
import AboutSection       from "./About/AboutSection";
import GithubHeatmap      from "./About/GithubHeatmap";
import ExperienceSection  from "./Experience/ExperienceSection";
import ProjectsSection    from "./Projects/ProjectsSection";
import BlogsSection       from "./Blogs/BlogsSection";
import ResumeSection      from "./Resume/ResumeSection";
import ContactSection     from "./Contact/ContactSection";

function HomePage() {
  return (
    <>
      <HeroSection       />
      <AboutSection      />
      <GithubHeatmap     />
      <ExperienceSection />
      <ProjectsSection   />
      <BlogsSection      />
      <ResumeSection     />
      <ContactSection    />
    </>
  );
}

export default HomePage;
